const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const formatPrice = (value) =>
  "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Math.round(value));

export const resolveImg = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  return `${BACKEND_URL}${src.startsWith("/") ? "" : "/"}${src}`;
};

export const mainImage = (product) => {
  const img = (product.images && product.images[0]) || product.image || "";
  return resolveImg(img);
};
